import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { __ } from '@wordpress/i18n';

const SortableMainFieldItem = ({
  field,
  index,
  onMoveUp,
  onMoveDown,
  onToggle,
  onEdit,
  onConfigure,
  isEditing,
  editTitle,
  onEditTitleChange,
  onSaveEdit,
  onCancelEdit,
  fieldsLength,
  isDefault
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: field.id });
  
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : 1,
  };
  
  const hasConfigurableOptions = () => {
    return field.type === 'text' || field.type === 'taxonomy';
  };
  
  const hasConfig = () => {
    return field.config && Object.keys(field.config).length > 0;
  };
  
  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`hvnly_main_search_fields_drag_drop_builder_item ${isDragging ? 'dragging' : ''}`}
    >
      {isEditing ? (
        <div className="hvnly_main_search_fields_drag_drop_edit_form">
          <div className="hvnly_main_search_fields__form-group">
            <input
              type="text"
              className="hvnly_main_search_fields__form-control"
              value={editTitle}
              onChange={(e) => onEditTitleChange(e.target.value)}
              placeholder={__('Field title', 'havenlytics')}
            />
          </div>
          <div className="hvnly_main_search_fields_drag_drop_edit_actions">
            <button className="hvnly_main_search_fields__modern-btn hvnly_main_search_fields__modern-btn--primary" onClick={onSaveEdit}>
              <i className="fas fa-check"></i> {__('Save', 'havenlytics')}
            </button>
            <button className="hvnly_main_search_fields__modern-btn hvnly_main_search_fields__modern-btn--secondary" onClick={onCancelEdit}>
              <i className="fas fa-times"></i> {__('Cancel', 'havenlytics')}
            </button>
          </div>
        </div>
      ) : (
        <>
          <div className="hvnly_main_search_fields_drag_drop_builder_item_handle" {...attributes} {...listeners}>
            <i className="fas fa-grip-vertical"></i>
          </div>
          
          <div className="hvnly_main_search_fields_drag_drop_builder_item_content">
            <div className="hvnly_main_search_fields_drag_drop_builder_item_title">
              {field.title}
              {isDefault && <span className="hvnly-main-default-badge">{__('Default', 'havenlytics')}</span>}
              {hasConfig() && (
                <span className="hvnly-main-configured-badge">
                  <i className="fas fa-check-circle"></i> {__('Configured', 'havenlytics')}
                </span>
              )}
            </div>
            <div className="hvnly_main_search_fields_drag_drop_builder_item_type">
              {field.typeLabel || field.type}
            </div>
          </div>
          <div className="hvnly_main_search_fields_drag_drop_builder_item_actions">
            <button className="hvnly_main_search_fields_drag_drop_builder_item_action_btn" onClick={() => onToggle(field.id)} title={field.enabled ? __('Disable', 'havenlytics') : __('Enable', 'havenlytics')}>
              <i className={field.enabled ? 'fas fa-toggle-on' : 'fas fa-toggle-off'}></i>
            </button>
            <button className="hvnly_main_search_fields_drag_drop_builder_item_action_btn" onClick={() => onMoveUp(field.id)} disabled={index === 0} title={__('Move Up', 'havenlytics')}>
              <i className="fas fa-arrow-up"></i>
            </button>
            <button className="hvnly_main_search_fields_drag_drop_builder_item_action_btn" onClick={() => onMoveDown(field.id)} disabled={index === fieldsLength - 1} title={__('Move Down', 'havenlytics')}>
              <i className="fas fa-arrow-down"></i>
            </button>
            <button className="hvnly_main_search_fields_drag_drop_builder_item_action_btn" onClick={() => onEdit(field)} title={__('Edit Title', 'havenlytics')}>
              <i className="fas fa-edit"></i>
            </button>
            {hasConfigurableOptions() && (
              <button className="hvnly_main_search_fields_drag_drop_builder_item_action_btn" onClick={() => onConfigure(field)} title={__('Configure Field Options', 'havenlytics')} style={{ color: 'var(--hvnly-brand-primary)' }}>
                <i className="fas fa-cog"></i>
              </button>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default SortableMainFieldItem;